import { useState } from "react";

export default function ProductImageViewer({ images }) {
  const [imgError, setImgError] = useState(false);

  return (
    <div className="w-full max-w-[200px] sm:max-w-xs md:max-w-md bg-white rounded-xl shadow-md p-3 mx-auto">
      {/* Main image */}
      <div className="relative flex justify-center items-center bg-gray-50 rounded-lg overflow-hidden w-full h-48 sm:h-60 md:w-[400px] md:h-[400px]">
        {!imgError ? (
          <img
            src={images[0].large}
            alt={images[0].alt}
            onError={() => setImgError(true)}
            className="object-contain w-full h-full"
            style={{ transform: `scale(${images[0].scaleImage || 1})` }}
          />
        ) : (
          <div className="flex items-center justify-center w-full h-full bg-gray-100">
            <span className="text-gray-400">Image not available</span>
          </div>
        )}
      </div>
    </div>
  );
}